export default __webpack_public_path__ + "static/media/3-1.9ce525b1.mp3";